import React from 'react'
import logger from 'util/logger'
import router from 'next/router'
import { TimeoutError } from 'src/components/timeout-error'

const ErrorMessage = ({ error }) => {
  if (error.name === 'ChunkLoadError') {
    return (
      <span className="flex flex-col items-center justify-center">
        The application has been updated. Please refresh your browser to see the
        latest content.
        <button
          className="yd-button mt-2"
          onClick={() => {
            window.location.reload(true)
          }}>
          Reload
        </button>
      </span>
    )
  }
  if (error.name === 'ApolloError') {
    const anom = error.graphQLErrors[0]?.extensions?.anom
    if (
      anom?.['yd-anom/category'] === 'busy' &&
      anom?.['yd-anom/error-code'] === 'gql-request-timeout'
    ) {
      return <TimeoutError />
    }
  }

  return <p>Something went wrong.</p>
}
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidMount() {
    router.events.on('routeChangeComplete', () => {
      this.setState({ hasError: false })
    })
  }

  componentDidCatch(error, errorInfo) {
    logger.error(error, { source: 'didcatch', errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="global-error-boundary"
          className="flex min-h-screen w-full items-center justify-center">
          <ErrorMessage error={this.state.error} />
        </div>
      )
    }
    return this.props.children
  }
}
